import { Box } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  minColumnWidth?: string;
  gap?: string;
}

export function Grid({ children, minColumnWidth = '4rem', gap }: Props) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fit, minmax(${minColumnWidth}, 1fr))`,
        gap,
      }}
    >
      {children}
    </Box>
  );
}
